import type { BrandWizardStep } from '@mg/shared';
import { stepFieldKeys } from '../draft/brandDraft';
import { WizardField } from './WizardField';

/**
 * A step that is a plain list of fields, one per row and full width (spec:255): Brand identity (3),
 * Brand voice (4) and Market (8), and the fields under step 2's copy control.
 */
export function FieldsStep({ step, disabled = false }: { step: BrandWizardStep; disabled?: boolean }) {
  return (
    <>
      {stepFieldKeys(step).map((key) => (
        <WizardField key={key} fieldKey={key} disabled={disabled} />
      ))}
    </>
  );
}
